module.exports = __webpack_public_path__ + "img/active-substep.1adb26b0.svg";